import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import {
  FeatureSettingsService,
  IAppFeatures,
  MV_AUTH_TOKEN_STORAGE_KEY,
  mvAuthGuard,
} from '@vbrick/vb-lxp-lib';
import { catchError, throwError } from 'rxjs';
import { LivestreamViewComponent } from './livestream-view/livestream-view.component';
import { FullTimingComponent } from './full-timing/full-timing.component';

const featureSettingsResolver: ResolveFn<IAppFeatures> = () =>
  inject(FeatureSettingsService)
    .loadFeatureSettings()
    .pipe(
      catchError((error) => {
        console.error('Failed to load feature settings:', error);
        return throwError(() => error);
      }),
    );

export const routes: Routes = [
  {
    path: '',
    component: LivestreamViewComponent,
    resolve: {
      featureSettings: featureSettingsResolver,
    },
    data: {
      showLayoutControls: true,
      showTimingControl: true,
      showChatControl: true,
      showMapControl: false,
    },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@vbrick/vb-lxp-lib').then((m) => m.VbLxpLoginComponent),
    data: {
      title: 'Admin Login',
      subtitle: 'Sign in to access admin settings',
      loginPath: 'api/admin/login',
      redirectTo: '/admin',
      authStorageKey: MV_AUTH_TOKEN_STORAGE_KEY,
    },
  },
  {
    path: 'admin/login',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    canActivate: [mvAuthGuard],
    data: {
      authStorageKey: MV_AUTH_TOKEN_STORAGE_KEY,
      authRedirectTo: '/login',
    },
    loadComponent: () =>
      import('@vbrick/vb-lxp-lib').then((m) => m.VbLxpAdminComponent),
  },
  {
    path: 'full-timing',
    component: FullTimingComponent,
    data: {
      showLayoutControls: false,
      showTimingTowerControl: false,
      showChatControl: false,
      showMapControl: true,
    },
  },
];
